import { FieldType, Operator } from '../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import SetValue from './SetValue';
import ComparisonValue from './ComparisonValue';
import DateCriterionValue from '../dateCriterionValue';

const BooleanValue = ({
  selectedOperator,
  selectedFieldSubType,
  fieldName,
  showLabel,
  availableValueOptions,
  readOnly = false
}) => {
  if (selectedFieldSubType === FieldType.DATE) {
    return (
      <DateCriterionValue
        selectedOperator={selectedOperator}
        fieldName={fieldName}
        showLabel={showLabel}
        readOnly={readOnly}
      />
    )
  } else {
    switch (selectedOperator) {
      case Operator.EQUAL:
      case Operator.NOT_EQUAL:
        return (
          <EqualValue
            fieldName={fieldName}
            showLabel={showLabel}
            availableValueOptions={availableValueOptions}
            readOnly={readOnly}
          />
        );
      case Operator.IN_SET:
      case Operator.NOT_IN_SET:
        return (
          <SetValue
            fieldName={fieldName}
            showLabel={showLabel}
            availableValueOptions={availableValueOptions}
            readOnly={readOnly}
          />
        );
      case Operator.GREATER_THAN:
      case Operator.GREATER_OR_EQUAL:
      case Operator.LESS_THAN:
      case Operator.LESS_OR_EQUAL:
        return <ComparisonValue
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      default:
        return <></>;
    }
  }
};

export default BooleanValue;
